import React from 'react';

const Logout = ({ handleLogout }) => {
  return (
    <div>
      <button onClick={handleLogout}><b>Logout</b></button>
    </div>
  );
};

export default Logout;